.header {
    display: flex;
    gap: 1rem;
}

.inventoryImage {
    padding: 0.5rem;
    border-radius: 12px;
    border: 1px solid var(--static-divider-standard);
}

.metaDataContainer {
    display: flex;
    flex-direction: column;
}

.metaDataSubContainer {
    display: flex;
    flex-direction: column;
}

.metaDataTitle {
    font-size: var(--fs-normal);
    color: var(--static-text-strong);
    font-weight: 500;
    text-overflow: ellipsis;
    line-height: 24px;
    overflow: hidden;
    text-wrap: nowrap;
    max-width: 700px;
}

.skuAndCondition {
    display: flex;
    gap: 0.5rem;
}

.subTitleContainer {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.subMetaTitle {
    font-size: var(--fs-small);
    color: var(--static-text-weak);
    font-weight: 400;
    line-height: 16px
}

.subMetaValue {
    font-size: var(--fs-small);
    color: var(--static-text-standard);
    font-weight: 400;
    line-height: 16px
}

.buttonContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.cancelSaveButtons {
    display: flex;
    gap: 0.75rem;
}

.dot {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--static-text-weak);
    font-size: 12px
}

.statusBadge {
    font-size: var(--fs-small);
}

.modalFooter {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.modal {
    min-width: 60rem;
}

.skeletonContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid var(--static-divider-standard);
}

.variableBuyCostBody {
    border-radius: 12px;
    border: 1px solid var(--static-divider-standard);
}

.initialPurchase {
    padding: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 180px;
}

.initialPurchaseFlexItem {
    /*flex-basis: 33.33%;*/
    /*flex-shrink: 0;*/
    /*flex-grow: 0;*/
}

.smallTitleText {
    font-size: var(--fs-small);
    font-weight: 500;
    line-height: 16px;
}

.verticalContainer {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.totalInput {
    /*border-radius: 8px;*/
    /*border: 1px solid var(--static-divider-standard);*/
    background: var(--static-divider-standard);
    /*padding: 0.25rem 0.75rem;*/
    font-size: var(--fs-small);
}

.datePicker {

}

.datePicker .ant-picker .ant-picker-input > input {
    font-size: 14px !important;
}

.costCategoryHeader {
    display: flex;
    font-size: var(--fs-small);
    font-weight: 500;
    line-height: 20px;
}

.table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.tableHeaderCell {
    font-size: var(--fs-small);
    font-weight: 500;
    line-height: 20px;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 1.5rem;
    text-align: left;
}

.tableRow {
    border-bottom: 1px solid var(--static-divider-standard);
}

.closeButtonContainer {
    display: flex;
    justify-content: center;
}

.closeButton {
    cursor: pointer;
    background-color: transparent;
    border: none;
    /*padding: 0.5rem;*/
    /*z-index: 2;*/
    color: var(--static-text-standard);
}

.tableCell {
    padding: 0.625rem 1.5rem;
}

.lastTableHeaderCell {
    width: 5rem;
}

.text {
    font-size: var(--fs-small);
}

.emptyDiv {
    width: 5rem;
}

.stockSectionsContainer {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.modalBody {
    max-height: 70vh;
    overflow-y: scroll;
}

